import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { PROCEDURE_STEPS } from 'containers/data-structure';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { formatCourtFileNumber } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';

export const judgementAddFormatorAppeal = (
  claimId: number,
  details: Idetails,
  judgementAddDocuments: JudgementADDDocumentType[],
  listing: any,
  policyInfo: any,
  withFeeNote: boolean,
  isCourtManager: boolean,
) => {
  return {
    claimId,
    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
    status: isCourtManager
      ? PROCEDURE_STATUSES.VALIDATED
      : PROCEDURE_STATUSES.PENDING,
    procedureType: 'APPEAL',
    judgementAddDocuments,
    details: {
      ...details,
      courtFile: formatCourtFileNumber(details.courtFile),
    },
    fflipFeeNote: withFeeNote
      ? featureService.hasFeature(FEATURES.FEE_NOTE)
      : undefined,
    username: isCourtManager
      ? currentUserStorage.get().username
      : currentIntervenantStorage?.get()?.preferred_username,
    ...(isCourtManager
      ? {
          validator: currentUserStorage.get().username,
        }
      : undefined),
  };
};
